import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound404 from "../../pages/error/NotFound404";
import DispenserDashboard from "../../pages/dashboard/DispenserDashboard";

import PendingBranchInventoryRequisition from "../../pages/Inventory/Requisition/PendingBranchInventoryRequisition";
import DispatchedBranchInventoryRequisition from "../../pages/Inventory/Requisition/DispatchedBranchInventoryRequisition";

const DispenserRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<DispenserDashboard />} />
      <Route path="/inventory/requisition/requested" element={<PendingBranchInventoryRequisition />} />
      <Route path="/inventory/requisition/dispatched" element={<DispatchedBranchInventoryRequisition />} />
      <Route path="/*" element={<NotFound404 />} />
    </Routes>
  );
};

export default DispenserRoutes;
